import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = ({ currentPage, setCurrentPage, user, handleLogout }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
              PureDegen
            </h1>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => setCurrentPage('home')}
              className={`${currentPage === 'home' ? 'text-green-600' : 'text-gray-700'} hover:text-green-600 transition`}
            >
              Home
            </button>
            <button
              onClick={() => setCurrentPage('tipsters')}
              className={`${currentPage === 'tipsters' ? 'text-green-600' : 'text-gray-700'} hover:text-green-600 transition`}
            >
              Tipsters
            </button>
            <button
              onClick={() => setCurrentPage('tracker')}
              className={`${currentPage === 'tracker' ? 'text-green-600' : 'text-gray-700'} hover:text-green-600 transition`}
            >
              Bet Tracker
            </button>
            <button
              onClick={() => setCurrentPage('degen-system')}
              className={`${currentPage === 'degen-system' ? 'text-green-600' : 'text-gray-700'} hover:text-green-600 transition`}
            >
              Degen System
            </button>
            <button
              onClick={() => setCurrentPage('wellness')}
              className={`${currentPage === 'wellness' ? 'text-green-600' : 'text-gray-700'} hover:text-green-600 transition`}
            >
              Wellness
            </button>
            <button
              onClick={() => setCurrentPage('pricing')}
              className={`${currentPage === 'pricing' ? 'text-green-600' : 'text-gray-700'} hover:text-green-600 transition`}
            >
              Pricing
            </button>
          </div>
          <div className="hidden md:flex items-center gap-4">
            {user ? (
              <>
                <span className="text-sm text-gray-600">
                  {user.displayName || user.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="bg-gray-200 text-gray-700 px-4 py-2 rounded-full hover:bg-gray-300 transition"
                >
                  Logout
                </button>
              </>
            ) : (
              <button
                onClick={() => setCurrentPage('login')}
                className="bg-gradient-to-r from-green-400 to-blue-400 text-white px-4 py-2 rounded-full hover:opacity-90 transition"
              >
                Login / Sign Up
              </button>
            )}
          </div>
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700 hover:text-green-600"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {['home', 'tipsters', 'tracker', 'degen-system', 'wellness', 'pricing'].map((page) => (
                <button
                  key={page}
                  onClick={() => {
                    setCurrentPage(page);
                    setMobileMenuOpen(false);
                  }}
                  className={`block w-full text-left px-3 py-2 rounded-md ${
                    currentPage === page ? 'bg-green-100 text-green-600' : 'text-gray-700'
                  } hover:bg-green-50`}
                >
                  {page === 'degen-system' ? 'Degen System' : page.charAt(0).toUpperCase() + page.slice(1)}
                </button>
              ))}
              {user ? (
                <button
                  onClick={() => {
                    handleLogout();
                    setMobileMenuOpen(false);
                  }}
                  className="block w-full text-left px-3 py-2 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Logout
                </button>
              ) : (
                <button
                  onClick={() => {
                    setCurrentPage('login');
                    setMobileMenuOpen(false);
                  }}
                  className="block w-full text-left px-3 py-2 rounded-md text-gray-700 hover:bg-green-50"
                >
                  Login / Sign Up
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;